__turbopack_context__.v({
  "transactional-cta-button": "enrolled-sticky-footer-content-module-scss-module__0XDQRW__transactional-cta-button",
});
